import axios from 'axios'

import { environmentVariables } from '../../utils/environmentVariables'

const apiClient = axios.create({
  headers: {
    'X-Swile-Platform': 'web',
  },
})

export const isAffiliate = async (accessToken: string): Promise<boolean> => {
  const TIMEOUT = 1000 // Do not make 99% of our users wait for more than 1 second.
  const checkAccessUrl = environmentVariables('AFFILIATES_ACCESS_CHECK_URL')
  try {
    await apiClient.head(checkAccessUrl, {
      timeout: TIMEOUT,
      headers: { authorization: `Bearer ${accessToken}` },
    })
    return true
  } catch {
    return false
  }
}
